import {
  AdviceProductDetailsFormValues,
  DisabilityPension,
  WorkSituation,
} from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";

export const mapHasEmployerPaidDisabilityInsurance = (
  formValues: AdviceProductDetailsFormValues,
): boolean =>
  formValues.workSituation === WorkSituation.WORK_PUBLIC ||
  formValues.disabilityPension === DisabilityPension.YES;
